enum StarbucksOrderType {
  InStore = 'in-store',
  DriveThru = 'drive-thru',
  Curbside = 'curbside',
  Outdoor = 'outdoor',
}

export { StarbucksOrderType };
